export default __webpack_public_path__ + "volume-aaa130c3ed72d1321d39e5d0df079540.svg";